export const SET_DRAG_SOURCE = 'SET_DRAG_SOURCE';
export const SET_DRAGGING_FIELD = 'SET_DRAGGING_FIELD';
export const SET_SECTION_OVER_ID = 'SET_SECTION_OVER_ID';
export const SET_DRAG_AVAILABILITY = 'SET_DRAG_AVAILABILITY';
export const SET_NEW_SECTION_TYPE = 'SET_NEW_SECTION_TYPE';
export const SET_SECTION_COUNT = 'SET_SECTION_COUNT';